import {
  BaSeBox,
  BaSeBreakpointContext,
  BaSeButton,
  BaSeContainer,
  BaSeDialogContext,
  BaSeHeading6,
  BaSeIcon,
  BaSeMessage,
  BaSeShapeButton,
  BaSeTheme,
} from '@base/react';
import * as Sebrae from '@sebrae/react-core';
import download from 'downloadjs';

import React from 'react';
import { CERTIFICADO_ENDPOINT } from '../../hooks/constants';
import {
  ContentCardReport,
  ContentHeaderBox,
  WrapperReport,
} from './importar-certificados-styled';

export const RelatorioCertificadosLote = ({ responseFiles, notifyMessage }) => {
  const [indexLoading, setIndexLoading] = React.useState(-1);
  const [isNotify, setIsNotify] = React.useState(true);
  const { onDesktop, onDesktopLarge } = React.useContext(BaSeBreakpointContext);
  const { showNotification } = React.useContext(BaSeDialogContext);
  const { backendPostBlob } = Sebrae.useBackend();
  const { navigateTo } = Sebrae.useRouter();
  const { azulSebrae36, cinzaSebrae45, cinzaSebrae60, cinzaSebrae75 } =
    BaSeTheme.colors.institucionais;
  const { erro35, atencao35, sucesso20 } = BaSeTheme.colors.feedbackInterface;
  const { white } = BaSeTheme.colors.defaultColors;

  const isDesktop = React.useCallback(
    () => onDesktop || onDesktopLarge,
    [onDesktop, onDesktopLarge],
  );

  const downloadError = React.useCallback(
    (item, index, isErro, isSuccess) => {
      const date = new Date();
      const fileNameDate = Intl.DateTimeFormat('pt-BR', {
        timeStyle: 'medium',
        dateStyle: 'short',
      })
        .format(date)
        .replace(/\D/g, '');
      setIndexLoading(index);
      backendPostBlob(
        `${CERTIFICADO_ENDPOINT}/lote/xlsx?registrosErro=${isErro}&registrosSucesso=${isSuccess}`,
        item,
      )
        .then((blob) => {
          download(
            blob,
            `${fileNameDate}_certificados_com_${isErro ? 'erro' : 'sucesso'}`,
            blob.type,
          );
          showNotification({
            message: `Download realizado com sucesso.`,
            color: 'confirmation',
          });
        })
        .catch((error) => {
          showNotification({
            message: `Erro ao fazer download do arquivo`,
            color: 'destructive',
          });
        })
        .finally(() => {
          setIndexLoading(-1);
        });
    },
    [backendPostBlob, showNotification],
  );

  const ActionCard = ({
    item,
    index,
    nameButton,
    isErro = false,
    isSuccess = false,
  }) => (
    <div style={{ marginLeft: isDesktop() ? 'auto' : 'initial' }}>
      <BaSeButton
        isLoading={indexLoading === index}
        value={nameButton}
        type="secondary"
        leftIcon="file-download"
        size="small"
        color={cinzaSebrae45}
        onClick={() => downloadError(item, index, isErro, isSuccess)}
      />
    </div>
  );

  const CardReport = ({ item, index }) => {
    const pluralError = item.totalErro > 1 ? 's' : '';
    const pluralSuccess = item.totalSucesso > 1 ? 's' : '';
    return (
      <>
        {item?.totalErro > 0 && (
          <WrapperReport isDesktop={isDesktop()}>
            <BaSeHeading6 color={erro35}>{`${
              item.totalErro
            } registro${pluralError} com erro que não ${
              item.totalErro > 1 ? 'foram' : 'foi'
            } gerado${pluralError}`}</BaSeHeading6>
            <ActionCard
              index={index}
              item={item}
              nameButton="Baixar arquivo de erros"
              isErro
            />
          </WrapperReport>
        )}
        {item?.totalSucesso > 0 && (
          <WrapperReport isDesktop={isDesktop()}>
            <BaSeHeading6
              color={sucesso20}
            >{`${item.totalSucesso} certificado${pluralSuccess} gerado${pluralSuccess} com sucesso`}</BaSeHeading6>
            <ActionCard
              item={item}
              index={index + 0.1}
              nameButton="Baixar arquivo de certificados gerados"
              isSuccess
            />
          </WrapperReport>
        )}
      </>
    );
  };

  const CardsFiles = ({ item, index }) => {
    return (
      <>
        <BaSeBox
          backgroundColor={white}
          borderColor={cinzaSebrae75}
          shadowLevel={2}
          elevationOnHoverOrFocus={false}
          renderContent={() => [
            <ContentHeaderBox key={1}>
              <BaSeHeading6
                color={cinzaSebrae45}
              >{`Arquivo: ${item.nomeArquivo}`}</BaSeHeading6>
            </ContentHeaderBox>,
            <ContentCardReport key={2}>
              <CardReport item={item} index={index} />
            </ContentCardReport>,
          ]}
        />
      </>
    );
  };

  return (
    <BaSeContainer delimitedOnBreakpoint="desktop">
      <div
        style={{
          display: 'grid',
          gap: 20,
          marginBottom: 50,
        }}
      >
        {isNotify && (
          <BaSeMessage
            color={notifyMessage.color}
            title={
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                {notifyMessage.color === 'attention' && (
                  <BaSeIcon
                    color={atencao35}
                    description="Atenção"
                    name="exclamation-triangle"
                    size={16}
                  />
                )}
                {notifyMessage.color === 'destructive' && (
                  <BaSeIcon
                    color={erro35}
                    description="erro"
                    name="exclamation-octagon"
                    size={20}
                  />
                )}
                {notifyMessage.color === 'confirmation' && (
                  <BaSeIcon
                    color={sucesso20}
                    description="Sucesso"
                    name="check-circle"
                    size={20}
                  />
                )}

                <spam style={{ marginTop: 1 }}>{notifyMessage.message}</spam>
                <div style={{ marginLeft: 'auto' }}>
                  <BaSeShapeButton
                    color={cinzaSebrae60}
                    type="tertiary"
                    shape="circle"
                    sizeIcon="medium"
                    nameIcon="close"
                    size="medium"
                    onClick={() => setIsNotify(false)}
                  />
                </div>
              </div>
            }
            message={notifyMessage.supportMessage}
          />
        )}
        {!!responseFiles?.arquivos?.length &&
          responseFiles.arquivos.map((item, i) => (
            <CardsFiles key={i} item={item} index={i} />
          ))}
      </div>
      <div style={{ margin: '20px 0' }}>
        <BaSeButton
          value="Ir para listagem de certificados"
          type="primary"
          color={azulSebrae36}
          onClick={() => navigateTo('/certificados-cliente')}
        />
      </div>
    </BaSeContainer>
  );
};
